import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { GetRankResponseData } from '@/modules/manage-rank/type'
import { columns, writeAccessorKeys } from './constants'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useMemo } from 'react'

interface RankTableProps {
	data: GetRankResponseData[]
	total: number
	isLoading?: boolean
}

export default function RankTable({ data, total, isLoading }: RankTableProps) {
	const { data: user } = useQueryProfile()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.MANAGE_RANK,
	)

	const filteredColumns = useMemo(
		() =>
			columns.filter(
				(column) =>
					hasWritePermission ||
					('accessorKey' in column &&
						!writeAccessorKeys.includes(column.accessorKey)),
			),
		[hasWritePermission],
	)

	return (
		<div className="space-y-4">
			<div className="flex flex-wrap items-center gap-4">
				<DataTableResetFilter />
			</div>
			<DataTablePaginate
				columns={filteredColumns}
				data={data}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
